import styled, { css } from 'styled-components/macro';
import { Input } from '../inputs.styled';

export const CustomizedInput = styled(Input)<{
  $icon: boolean;
  $actionIcon: boolean;
}>`
  ${({ theme, $icon, $actionIcon }) => css`
    padding: ${theme.spacings.componentOnly}
      ${$actionIcon ? theme.spacings.l : theme.spacings.s}
      ${theme.spacings.componentOnly}
      ${$icon ? theme.spacings.l : theme.spacings.s};
  `}
`;

export const Icon = styled.img`
  ${({ theme }) => css`
    margin: auto auto auto ${theme.spacings.s};
    position: absolute;
    z-index: 2;
    inset: 0;
    width: 16px;
    height: 16px;
  `}
`;
